import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ROUTING_CONGELAMIENTOS_SALDOS } from "../shared/common/constants/url.constant";
import { CongelamientoSaldosComprobanteComponent } from "./pages/congelamiento-saldos-comprobante/congelamiento-saldos-comprobante.component";
import { CongelamientoSaldosConfirmarComponent } from "./pages/congelamiento-saldos-confirmar/congelamiento-saldos-confirmar.component";
import { CongelamientoSaldosCuentasObligatoriasComponent } from "./pages/congelamiento-saldos-cuentas-obligatorias/congelamiento-saldos-cuentas-obligatorias.component";
import { CongelamientoSaldosCuentasVoluntariasComponent } from "./pages/congelamiento-saldos-cuentas-voluntarias/congelamiento-saldos-cuentas-voluntarias.component";
import { CongelamientoSaldosCuentasComponent } from "./pages/congelamiento-saldos-cuentas/congelamiento-saldos-cuentas.component";
import { CongelamientoSaldosHomeComponent } from "./pages/congelamiento-saldos-home/congelamiento-saldos-home.component";
import { CongelamientoSaldosComponent } from "./pages/congelamiento-saldos/congelamiento-saldos.component";

const CAMBIO_VIA_PAGO_PENSION_ROUTES: Routes = [
  {
    path: "",
    redirectTo: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_HOME,
    pathMatch: "full",
  },
  {
    path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_HOME,
    component: CongelamientoSaldosHomeComponent,
  },
  {
    path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_COMPROBANTE,
    component: CongelamientoSaldosComprobanteComponent,
  },
  {
    path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS,
    component: CongelamientoSaldosComponent,
    children: [
      {
        path: "",
        redirectTo: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CUENTAS,
        pathMatch: "full",
      },
      {
        path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CUENTAS,
        component: CongelamientoSaldosCuentasComponent,
        children: [
          {
            path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CUENTAS_OBLIGATORIAS,
            component: CongelamientoSaldosCuentasObligatoriasComponent,
          },
          {
            path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CUENTAS_VOLUNTARIAS,
            component: CongelamientoSaldosCuentasVoluntariasComponent,
          },
        ],
      },
      {
        path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CUENTAS_OBLIGATORIAS,
        component: CongelamientoSaldosCuentasObligatoriasComponent,
      },
      {
        path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CONFIRMAR,
        component: CongelamientoSaldosConfirmarComponent,
      },
      
    ],
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(CAMBIO_VIA_PAGO_PENSION_ROUTES)],
  exports: [RouterModule],
})
export class CongelamientoSaldosRoutingModule {}
